import { NovelGalleryThunkAction } from "@customer-gallery/redux/galleryTypedRedux";
import { asyncDispatch } from "@customer-gallery/redux/utils/asyncDispatch";

import { typedFrontendGalleryApi } from "@customer-gallery/utils/typedFrontendGalleryApi";

export const loadDiscounts =
    (): NovelGalleryThunkAction<
        "LOADING_DISCOUNTS" | "ERROR_LOADING_DISCOUNTS" | "LOADED_DISCOUNTS"
    > =>
    async (dispatch) =>
        asyncDispatch(
            typedFrontendGalleryApi.getReq(`/api/customer/benefits`),
            () =>
                dispatch({
                    type: "LOADING_DISCOUNTS",
                    payload: undefined,
                }),
            (failure) =>
                dispatch({
                    type: "ERROR_LOADING_DISCOUNTS",
                    payload: {
                        errorMessage: failure.error.message,
                    },
                }),
            ({ totalCustomerDiscounts }) =>
                dispatch({
                    type: "LOADED_DISCOUNTS",
                    payload: { totalCustomerDiscounts },
                }),
        );
